/*
 * @Descripttion:
 * @version:
 * @Author: renqiang_hu
 * @Date: 2022-12-17 09:09:58
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-01-15 16:27:13
 * @FilePath: \heshan_web\src\lang\ko.js
 */
export default {
    tip: '힌트',
    title: '백그라운드 관리 시스템',
    logoutTip: '시스템을 종료합니다.계속하시겠습니까?',
    submitText: '확인',
    cancelText: '취소',
    search: '검색 내용 입력',
    menuTip: '메뉴를 찾을 수 없습니다',
    wel: {


      project: '프로젝트 액세스',
      count: '항목 수',

    },
    route: {
      info: '개인 정보',
      website: 'bladex',
      avuexwebsite: 'avue',
      dashboard: '첫 장',
      more: '더',
      tags: '상표',
      store: '로컬 스토리지',
      api: '全局函数',
      logs: '日志监控',
      table: '시트',
      form: '시트',
      top: '맨 위로',
      data: '데이터 표시',
      permission: '权限',
      error: '예외 페이지',
      test: '测试页面'
    },
    login: {
      title: '로그인',
      info:'백그라운드 관리 시스템',
      tenantId: '세입자 ID를 입력하십시오.',
      username: '계좌번호 (핸드폰 번호) 를 입력하세요.',
      password: '암호를 입력하십시오',
      forpass:'암호를 잊었습니다',
      phone: '계정 또는 모바일 비밀번호 입력',
      code: '인증코드 입력',

      submit: '로그인',
      userLogin: '계정 비밀번호 로그인',
      phoneLogin: '휴대폰 번호 로그인',
      thirdLogin: '다른계정으로 로그인',
      msgText: '인증코드보내기',
      msgSuccess: '秒后重发',
    },
    navbar: {
      logOut: '로그 아웃',
      userinfo: '개인 정보',
      dashboard: '첫 장',
      lock: '잠금 화면',
      bug: '오류 로그 없음',
      bugs: '조 오류일',
      screenfullF: '전체 화면 종료',
      screenfull: '전체 화면',
      language: '中英文',
      notice: '메시지 알림',
      theme: '주제',
      color: '색상 변경',
      reset: '초기화'
    },
    tagsView: {
      search: '검색',
      menu: '추가',
      clearCache: '캐시 지우기',
      closeOthers: '기타 닫기',
      closeAll: '모두 닫기'
    },
    // 实时页面
    realtimeinfo:{
      checkDev:"항목선택",
      search:"검색",
      roomNum:"바닥",
      eleNum:"엘리베이터 번호",
      offLine:'오프라인',
      onLine:"온라인",
      turnOff:"전원 끄기",
      powerOn:"전원 켜기",
      standard:"기준",
      eleTem:"자동차 온도"

    },
    realdetile:{
      filterAir:"에어컨 선택",
      eleInfo:'에어컨 정보',
      infoPara:"정보 매개변수",
      faultInfo:"오류 정보",
      setPara:"매개변수 설정",
      water:"수위 지시",
      view:"확인하다",
      search:"검색",
      operaStatus:"실행 상태",
      opera:"작동",
      return:"반환",
      serNum:"일련 번호",
      airconditionalNum:"에어컨 대수",
      contUnit:"접촉부",
      projectStatus:"프로젝트 상태",

      delayOff:"종료 지연",
      modelDetail:"모드 상세 정보",
      choAir:"기기 선택",
      pleInputAirCode:"에어컨 번호 입력",
      timeModeView:"타이밍 모드 정보 보기",
      eleTem:"엘리베이터 내부 온도",
      waterLevel:"수위",
      suVoltage:"전압",
      totalCurrent:"총 전류",
      coilTemp:"코일 온도",
      windTem:"송풍온도",
      heating:"난방",
      refrigeration:"냉방",
      setwindSpeed:"풍속 설정",
      highWind: "강풍",
      wind:"급기",
      lowWind:"미풍",
      on:"운전",
      off:"일시 정지",
      defrosting:",크림",
      highWindStatus:"고풍 계전기 상태",
      lowWindStatus:"저풍 계전기 상태",
      waterPumpStatus:"펌프 계전기 상태",
      heatStatus:"가열 릴레이 상태",
      paStatus:"압축 계전기 상태",
      eleTemFail:"엘리베이터 가마 온도 센서 고장",
      windTemFail:"송풍 온도 센서 고장",
      coilTemFail:"디스크 튜브 온도 센서 고장",
      airCho:"에어컨 검사",
     },
    //远程操作
    manipulation:{
      questTimedOut:"요청 시간 초과, 다시 실행하십시오",
      executing:"指令执行中",
      sglOpera:"단일 작업",
      bulkOpera:"다중 제어",
      select:"기기 선택",
      devName:"프로젝트 이름",
      buildNum:"바닥",
      ladderNum:"엘리베이터 번호",
      airModel:"에어컨 모델",
      installAddress:"설치 주소",
      executionResult:"명령 실행 결과",
      airModelSetting:"A/C 운전 모드 설정",
      airParameterSetting:"어컨 매개변수 설정",
      manual:"설명서",
      timing:"타이밍",
      sleepModeOff:"절전 모드 끄기",
      sleepModeOn:"절전 모드 켜기",
      sleepMode:"절전 모드",
      manModeParSetting:"수동 모드 매개변수 설정",
      timModeParSetting:"타이밍 모드 파라미터 설정",
      manMode:"수동 모드",
      timMode:"타이밍 모드",
      ParSetting:"매개변수 설정",
      choice:"선택한 에어컨",
      benTimeSetting:"시간 설정",
      curHour:"현재 시간",
      currentWeek:"금 주",
      timingSetting:"자동 운전 시간 설정",
      addTime:"자동 운전 추가",
      timer:"자동운전",
      timedOn:"시간 초과",
      timedOff:"시간 종료",
      model:"모델",
      temp:"온도",
      windSpeed:"풍속",
      week:"주기",
      cancel:"취소",
      sure:"확인",
      airNum:"프로잭트이름",
      elevatorBrand:"엘리베이터 브랜드",
      deviceAdressNum:"기기 주소 코드",
      comBoard:"통신보드 IMEI 코드",
      comStatus:"통신 상태",
      workStatus:"작업 상태",
      operaMode:"작동 모드",
      opeSec:"명령이 성공적으로 실행되었습니다",
      opefau:"명령어를 실행하는데 실패했습니다",

      pleChoiceAir:"먼저 에어컨을 선택하세요",
      opeSucc:"작업 성공",
      exDifAir:"현재 설정 모드와 다른 에어컨이 있습니다",
      sawBack:"톱등 압력 경보 역사",
      insNum:"설치 수",
      auto:"자동 운전",
      wind:"송풍",
      paSelect:"기본 설정",
      temRange:"온도 범위",
      devStatus:"에어컨 상태",
      anyTime:"임의의 시점",
      timeSet:"자동 운전 시간 설정"

    },
    //历史数据
    dataAnalysis:{
      deviceInfo:"장치 정보",
      timeChs:"시간 선택",
      monitorchs:"모니터링 포인트 선택",
      inquire:"문의",
      reset:"초기화",
      chart:"차트",
      form:"시트",
      time:"시간",
      prev:"이전 페이지",
      next:"다음 페이지",

      project:"프로젝트",
      lift:"엘리베이터",
      endTime:"종료일",
      startTime:"시작일",
      pleCho:"선택",
      unit:"단위",
      alFirstPage:"첫 페이지",
      alLastPage:"마지막 페이지",
      none:"데이터 없음",
    },
    //操作日志
    sendCmdLog:{
      queryMethod:"조회 모드",
      date:"날짜",
      actContent:"운영 내용",
      actResult:"작업 결과",
      actPeople:"운영자",
      pleAddCode:"주소 코드를 입력하세요",
      arrive:"-",
      startDate:"시작일",
      endDate:"종료일",
      addCodeQuery:"주소 코드로 검색",
      levelQuery:"레벨별 쿼리",
      today:"당일 ",
      lastWeek:"최근 일주일",
      lastMonth:"최근 한 달",
      success:"성공",
      fault:"실패",
    },
    //报警设置
    alarmSetting:{
      airModelQuire:"에어컨 모델 쿼리",
      addAlarm:"알람 추가",
      alarmName:"알람 이름",
      alarmLevel:"알람 레벨",
      assMonitor:"모니터링 포인트 연결",
      alarmContent:"알람 내용",
      triggerCondition:"트리거 조건",
      alarmType:"알람 유형",
      alarmThreshold:"경보 임계값",
      copMethodChoose:"대처 방법(선택 사항)(可选)",
      webAlarm:"web시스템 알람",
      alarmContacts:"알람 수신 연락처",
      assVariable:"관련 변수",
      alarm:"긴급연락처",
      delete:"삭제",
      edit:"편집",
      prompt:"힌트",
      promptContent:"삭제 하시겠습니까?",

      inputAlarmName:"알람 이름을 입력하세요",
      choAlarmType:"경고 유형을 선택하십시오",
      choAssVariable:"연관 변수를 선택하십시오",
      inputAlarmValue:"알람 값을 입력하세요",
      inputAlarmContent:"알람 내용을 입력하세요",
      editAlarm:"알람 수정",
      addSuc:"추가 성공",
      addFauRepeat:"기기를 추가하지 못했습니다. 다시 시도하거나 도움말을 참조하세요,请稍后重试",
      chaSuc:"수정 성공",
      chaFauRepeat:"수정에 실패했습니다. 나중에 다시 시도하십시오.",
      fillComplete:"공란을 채워주세요",
      deleteSuc:"성공적으로 삭제되었습니다.",
      deleteFau:"삭제 실패",
      airCode:"에어컨 코드",
      statusList:"상태 목록",
      number:"수량",
    },
    //报警数据
    alarmData:{
      monitorList:"모니터링 포인트 목록",
      dataName:"데이터 포인트 이름",
      curAlarmTime:"현재 알람 시간",
      dataValue:"데이터 값",
      status:"상태",
      processTime:"처리 시간",
      copMethod:"해결책",

      processed:"처리",
      notProcessed:"작업 오류",
      lookHistory:"과거 알람을 보려면 클릭하십시오",
      choiceDate:"날짜 선택",
      startDate:"시작일",
      endDate:"종료일",
      fail:"오류",
      numericValue:"수치",
      everyPage:"페이지당",
      strip:"条",
      currentPage:"현재 페이지",
      loading:"로드 중",
    },
    //人员管理
    userManage:{
      account:"계좌번호 (휴대폰번호)",
      operatorName:"작업자 이름",
      operaPermission:"작업 권한",
      addUser:"신규 사용자",
      userName:"사용자 이름",
      password:"비밀번호",
      phoneNum:"전화 번호",
      roleName:"역할 이름",

      pleInputProName:"프로젝트 이름을 입력하세요",
      newAdd:"신규",
      assignItem:"항목 할당",
      ifActivation:"활성화 여부",
      addAccountName:"사용자 이름을 추가",
      addPassword:"암호를 추가하십시오",
      addPhone:"휴대폰 번호를 추가",
      addRole:"请分配角色",
      phoneFault:"전화번호 오류",
      chaAccount:"사용자 수정",
      passLess:"密码长度最少为6位",
      revisePer:"편집 권한",
      addRoleName:"작업명을 추가해주세요",
      addRoleDes:"작업 설명을 추가해주세요",
      addUpRole:"상위 작업을 추가해주세요",
      addUpRole:"작업 추가",
      reviseRole:"작업 수정",
    },
    roleManage:{
      roleDescription:"작업 설명",
      createTime:"생성 시간",
      parentRole:"상위 작업",
      revise:"개정",

      updateSuc:"업데이트 완료",
      upDateFauRepeat:"업데이트에 실패했습니다. 다시 시도하십시오"

    },

    fileManage:{
      areaName:"지역명",
      add:"추가",
      timeSetting:"설치 시간",
      province:"주",
      city:"도시",
      longitude:"경도",
      latitude:"위도",
      contact:"연락",
      contactPhone:"연락처",
      installer:"설치 프로그램",
      map:"지도에서 지점 선택",
      keyWords:"키워드 검색",
      infoback:"삭제 확인",

      pleChoArea:"지역을 선택해 주세요",
      lookHisRevise:"수정 내역 보기",
      viewDetail:"자세히",
      handoff:"전환",
      insHisNameRevise:"설치현장 히스토리명 수정",
      chaAccount:"계정 변경",
      updateTime:"업데이트 시간",
      debug:"디버그",
      set:"운영",
      inputLongitude:"경도를 입력하세요",
      inputLatitude:"위도를 입력하세요",
      inputCityName:"도시 이름을 입력하세요",
      inputProvinceName:"지역명을 입력해주세요",

    },

    omcenter:{
      name:"이름",
      address:"주소",
      onlineDev:"온라인",
      offlineDev:"오프라인",
      devNum:"총 기기 수",
      hideDevName:"장치 이름 숨기기",
      piece:"조각",
      showDevName:"장치 이름 표시",
      hideDevName:"어플라이언스 이름 숨기기",
      inChina:"中国",
      devPlace:"장비 유통"
    },

    parmodel:{
      theMonday:"월요일",
      theTuesday:"화요일",
      theWednesday:"수요일",
      theThursday:"목요일",
      theFriday:"금요일",
      theSaturday:"토요일",
      theSunday:"일요일",
      temMoreRange:"온도가 범위를 벗어나다",
      necTimer:"타이머 컨텐트는 필수입니다.",
      temRangeIs:"온도 범위는",
      noTemEmpty:"온도는 비워둘 수 없습니다",
      pleTemRight:"온도가 올바르게 입력되었는지 확인하십시오",
      pointIssued:"명령이 내려졌습니다",
      mostAddTenPiece:"최대 10개 추가",
      leastOnePiece:"최소 1개",
    },

    stationModal:{
      assignmentDev:"장치 할당",
      devCode:"장비 번호",
      devModel:"기기 모델",
      devBh:'장치 번호',
      setSuc:"설정 성공",
      all:'모두',
      setFauRepeat:"设置失败,请稍后重试"
    },

    fileInfo:{
      pleInputAirCode:"에어컨 번호를 입력하세요",

      import:"수입EXCEL",
      clickLoad:"가져오려면 클릭",
      explain:"참고: 가져오기 파일 형식은 Excel 형식이어야 하며 먼저 템플릿을 클릭하여 다운로드할 수 있습니다.",
      downImport:"下载模板",
      boundBoard:"통신 보드 바인딩",
      totalAirModel:"에어컨 모델 통계",
      hangZhou:"杭州",
      place:"장소",
      pleSearchPlace:"검색할 장소를 입력",
      mapPoint:"지도에서 지점 선택",
      keySearch:"키워드 검색",
      boundType:'통신판 유형',
      devadress:'장치 주소',
      pleInputAirlh:'에어컨 건물 번호를 입력하십시오',
      pleInputAirth:'에어컨 사다리 번호를 입력하세요.',
      pleInputAirxh:'에어컨 모델을 입력하십시오.',
      pleInputAirpp:'엘리베이터 브랜드를 입력하십시오',
    },
  }
